module.exports = __webpack_public_path__ + "4187b1d40dd02e84f908f0b2c9d24236.svg";